import { User, UsersApi } from '@/api';
import { ApiUtils } from '@/common/ApiUtils';
import { AxiosError, AxiosResponse } from 'axios';
import { AddNewUserService } from './add-new-user-service';

export class AddProductPermissionService extends AddNewUserService {
	public selectedProductPermission: string | null = null;
	public permissionOptions = [
		{ value: 'product.user', text: 'User' },
		{ value: 'product.admin', text: 'Admin' },
	];

	constructor(private productId: number, protected usersApi: UsersApi = new UsersApi()) {
		super(usersApi);
	}

	public async save(): Promise<User | { error: string }> {
		if (!this.selectedProductPermission) {
			return { error: 'No product permission selected' };
		}
		if (!this.user.id) {
			const createdUserResponse = await super.save();
			if ('error' in createdUserResponse) {
				return createdUserResponse;
			}
			this.updateUserValues(createdUserResponse);
		}
		try {
			const createProductPermissionResponse = ((await this.usersApi.userPermission(this.user.id!, {
				data: {
					productId: this.productId,
					permission: this.selectedProductPermission,
					action: 'attach',
				},
			})) as unknown) as AxiosResponse<{ data: User }>;
			return createProductPermissionResponse.data.data;
		} catch (e) {
			const errorResponse = ApiUtils.handleApiError(
				e as AxiosError,
				'Failed to attach user to product: unknown error',
			);
			return { error: errorResponse.errorMessage };
		}
	}

	public cancel(): void {
		super.cancel();
		this.selectedProductPermission = null;
	}
}
